var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 31,
    viewBox: "0 0 151 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.107 18.531C119.135 -11.4676 56.0302 0.41078 2.29178 27.2799",
    stroke: "#8E93A2",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.856949 28.434C2.58586 27.2597 3.7489 25.3992 5.29159 23.9997",
    stroke: "#8E93A2",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10327 28.3025C1.49047 28.5244 3.46773 27.9844 3.78248 27.9495C5.48775 27.7608 7.05532 27.5607 8.68894 27.0898",
    stroke: "#8E93A2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameArrow3);
export default __webpack_public_path__ + "static/media/frame-arrow-3.321cbc523dfc45e63732a3ae4cb678a5.svg";
export { ForwardRef as ReactComponent };